var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AgmMap, AgmMarker } from '@agm/core';
import { AgmSnazzyInfoWindow } from '@agm/snazzy-info-window';
import { OnInit, QueryList } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { config } from '../../../../config/config';
import { CustomDefaultPlaceCategory, VisitorCalendarActionCommand } from '../../../commands/pagination.query.command';
import { BaseComponent } from '../../../common/components/base.component';
import { PageSpinnerComponent } from '../../../common/components/page.spinner/page.spinner.component';
import { PlaceCategory } from '../../../common/constants/constant';
import { getRouteUrl, routeConfigs } from '../../../common/constants/route.config';
import { GoogleMapsService } from '../../../common/services/google.maps.service';
import { HubPlace } from '../../../models/hub/hub.place';
import { HubVisitorFeatureToggle, HubVisitorToggleDataSource } from '../../../models/hub/hub.visitor.feature.toggle';
import { ConfigService } from '../../../services/config.service';
import { GeoService } from '../../../services/geo.service';
import { ImageService } from '../../../services/image.service';
import { PlaceService } from '../../../services/place.service';
import { VisitorApiService } from '../../../services/visitor.api.service';
import { AllFrontendSettingsStore, VisitorCalendarStore, VisitorDataCache, VisitorStyleStore, } from '../../../stores/visitor.calendar.store';
import { HubVisitorDataSource } from '../../../models/hub/hub.visitor.data.source';
import { PlaceDetailsModalActions } from '../place.details.modal/place.details.modal.provider';
import { PlaceDetailsModalComponent } from '../place.details.modal/place.details.modal.component';
import { ModalService } from '../../../common/services/modal.service';
import { TripDetailModalActions, TripDetailModalData } from '../trip/trip.detail.modal/trip.detail.modal.provider';
import { TripDetailModalComponent } from '../trip/trip.detail.modal/trip.detail.modal.component';
import { CustomDefaultPlaceCategoryItemSelectionStore } from '../../../stores/hub.calendar.store';
import { MatSidenav } from '@angular/material/sidenav';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { CustomDefaultPlaceCategoryAccordionComponent } from '../../hub/custom.default.place.category.accordion/custom.default.place.category.accordion.component.';
import { clone } from 'common/extensions';
import { CustomPlaceBtnComponent } from '../custom.place.btn/custom.place.btn.component';
import { isJsonString } from '../../../utils/common';
import { CustomizationApiService } from '../../../services/customization.api.service';
var VisitorPlaceMapComponent = /** @class */ (function (_super) {
    __extends(VisitorPlaceMapComponent, _super);
    function VisitorPlaceMapComponent(router, visitorApiService, googleMapService, imageService, modalService, customDefaultPlaceCategoryItemSelectionStore, visitorCalendarStore, visitorStyleStore, allFrontendSettingsStore, customizationApiService, activatedRoute) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.visitorApiService = visitorApiService;
        _this.googleMapService = googleMapService;
        _this.imageService = imageService;
        _this.modalService = modalService;
        _this.customDefaultPlaceCategoryItemSelectionStore = customDefaultPlaceCategoryItemSelectionStore;
        _this.visitorCalendarStore = visitorCalendarStore;
        _this.visitorStyleStore = visitorStyleStore;
        _this.allFrontendSettingsStore = allFrontendSettingsStore;
        _this.customizationApiService = customizationApiService;
        _this.activatedRoute = activatedRoute;
        _this.lat = ConfigService.config.google.USCenter.lat;
        _this.lng = ConfigService.config.google.USCenter.lng;
        _this.paginationIndex = 0;
        _this.paginationPageLimit = 20;
        _this.noMoreNext = false;
        _this.noMoreBack = true;
        _this.category = 'All';
        _this.categoryId = '';
        _this.actionCommand = new VisitorCalendarActionCommand();
        _this.showGroupInfowWindow = false;
        _this.canMarkerMouseOver = true;
        _this.isInfoWindowsOpen = [];
        _this.groupLat = 0;
        _this.groupLng = 0;
        _this.isLoading = false;
        _this.isInitLoading = false;
        _this.toggleAndSource = new HubVisitorToggleDataSource();
        _this.iconUrl = ConfigService.config.google.iconUrl;
        _this.hideIconMapStyler = ConfigService.config.google.hideMapBusinessIconStyles;
        _this.isSideBarOpened = false;
        _this.isNeedSideEventList = false;
        _this.isMapFullSize = false;
        _this.simpleMenu = false;
        _this.isHideEditorChoice = false;
        _this.loadingToggles = false;
        _this.featuresToggle = new HubVisitorFeatureToggle();
        _this.dataSource = new HubVisitorDataSource();
        _this.customDefaultPlaceCategory = new CustomDefaultPlaceCategory();
        _this.placeMapIcon = {
            Accommodations: config.tripPlanner.placeMapIcon.accommodation,
            'Dining & Nightlife': config.tripPlanner.placeMapIcon.dinging,
            Activities: config.tripPlanner.placeMapIcon.activity,
            Shopping: config.tripPlanner.placeMapIcon.shopping,
            'Outdoors & Fitness': config.tripPlanner.placeMapIcon.outdoor,
            Entertainment: config.tripPlanner.placeMapIcon.entertainment,
            Transportation: config.tripPlanner.placeMapIcon.transportation,
            Other: config.tripPlanner.placeMapIcon.other,
            Event: config.tripPlanner.eventMapIcon,
        };
        return _this;
    }
    VisitorPlaceMapComponent.prototype.ngOnInit = function () {
        var _this = this;
        var _a = this.allRouteParams, hubName = _a.hubName, category = _a.category, menuType = _a.menuType;
        this.hubName = hubName;
        this.category = category;
        this.categoryId = this.category;
        this.menuType = menuType;
        this.actionCommand.isMapView = true;
        this.actionCommand.queryCommand.category = category;
        this.actionCommand.queryCommand.isForMapView = true;
        // this.visitorCalendarStore.actionCommand.next(this.actionCommand);
        this.simpleMenu = menuType === 'simple';
        this.loadingToggles = true;
        this.allFrontendSettingsStore.allFrontendSettingsCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (command) {
            if (command.toggle) {
                _this.featuresToggle = command.toggle;
                _this.dataSource = command.dataSource;
                if (_this.isAllPlaceCategoriesTurnedOff) {
                    _this.featuresToggle.placeCalendar = false;
                }
                _this.toggleAndSource.toggle = _this.featuresToggle;
                _this.loadingToggles = false;
            }
            if (command.dataSource) {
                _this.toggleAndSource.dataSource = command.dataSource;
            }
            if (command.customSettings) {
                // map view for custom place btn
                if (_this.category === 'custom-places') {
                    _this.setForCustomPlaceBtn(command);
                }
                else {
                    // custom means now visiting a custom default place category, e.g., http://localhost:4200/test4/places/62a46ea3e6ad6016f05245ff/custom
                    // this needs to set the place category dropdown menu to only show that category
                    if (_this.menuType !== 'custom') {
                        _this.customDefaultPlaceCategory = command.customSettings.customDefaultPlaceCategory;
                    }
                    _this.setCustomDefaultPlaceCategory(command.customSettings.customDefaultPlaceCategory);
                    _this.getSelectedCategoryFromCalendar();
                }
            }
        });
    };
    VisitorPlaceMapComponent.prototype.setForCustomPlaceBtn = function (command) {
        var _this = this;
        this.spinner.show();
        this.category = 'All';
        this.customizationApiService.getCustomEvent(this.hubName).subscribe(function (custom) {
            _this.customPlaces = custom.customPlaces;
            var customBtn = custom.customPlaces.first(function (x) { return x._id.toString() === _this.menuType; });
            if (customBtn) {
                _this.customPlaceBtns.toArray().forEach(function (x) {
                    x.setFilter(customBtn.btnText);
                });
                _this.actionCommand.queryCommand.isCustom = true;
                _this.actionCommand.queryCommand.type = _this.menuType;
                _this.actionCommand.queryCommand.selectedPlaces = undefined;
                _this.actionCommand.queryCommand.limit = config.placeSearchLimit;
                _this.visitorApiService.getPlaces(_this.hubName, _this.actionCommand.queryCommand).subscribe(function (data) {
                    _this.customDefaultPlaceCategory = command.customSettings.customDefaultPlaceCategory;
                    _this.afterGotPlaces(data);
                });
            }
            else {
                alert('Wrong custom place button Id, please check!');
                _this.spinner.hide();
            }
        });
    };
    /**
     * if visit a custom default place category url, e.g., http://localhost:4200/test4/places/62a46ea3e6ad6016f05245ff/custom
     * */
    VisitorPlaceMapComponent.prototype.setCustomDefaultPlaceCategory = function (customDefaultPlaceCategory) {
        if (this.menuType === 'custom') {
            // this.category is the custom default place category id, e.g., 62a46ea3e6ad6016f05245ff
            var data = PlaceService.getCustomDefaultCategoryFromURL(this.category, customDefaultPlaceCategory);
            if (data) {
                this.categoryId = this.category;
                this.category = data.category.title;
                this.customDefaultPlaceCategory = customDefaultPlaceCategory;
                // this.customDefaultPlaceCategory = data.customDefaultPlaceCategory;
                // this.command.queryCommand.categoryList = data.categoryList;
                // const categoryString = JSON.stringify(data.category);
                this.initialCustomDefaultPlaceCategory = {
                    category: data.category,
                    categoryString: '',
                    categoryList: data.categoryList,
                };
                // for map view
                // localStorage.setItem(localStorageKeys.selectedPlaceCategory, categoryString);
            }
        }
        else {
            this.customDefaultPlaceCategory = customDefaultPlaceCategory;
        }
        // this.visitorCalendarStore.actionCommand.next(this.command);
    };
    VisitorPlaceMapComponent.prototype.getSelectedCategoryFromCalendar = function () {
        var _this = this;
        // get selected category from calendar and use
        var selectedPlaceCategoryStr = localStorage.getItem(localStorageKeys.selectedPlaceCategory);
        this.setCustomDefaultPlaceCategoryFilter();
        this.clearCustomBtnFilter();
        console.log('selectedPlaceCategoryStr', selectedPlaceCategoryStr);
        if (!selectedPlaceCategoryStr) {
            return this.getPlaces('All');
        }
        var selectedCustomPlaceCategory = isJsonString(selectedPlaceCategoryStr)
            ? JSON.parse(selectedPlaceCategoryStr)
            : selectedPlaceCategoryStr;
        console.log('selectedCustomPlaceCategory', selectedCustomPlaceCategory);
        // string: selected an IG default place category, otherwise it is a customized category, need to load its categoryList
        if (typeof selectedCustomPlaceCategory === 'string') {
            if (this.menuType === 'custom') {
                var place = PlaceService.getCustomDefaultPlaceCategoryById(selectedCustomPlaceCategory, this.customDefaultPlaceCategory);
                console.log('place...', place);
                this.getPlaces(this.category, place);
            }
            else {
                this.getPlaces(selectedCustomPlaceCategory);
            }
        }
        else {
            setTimeout(function () {
                // has 'actionCommand' and 'customBtnText' means it is a custom place button (see getFeedPlace function in custom.place.btn.component.ts), otherwise it is a custom default place category
                if (selectedCustomPlaceCategory && selectedCustomPlaceCategory['queryCommand']) {
                    _this.actionCommand = selectedCustomPlaceCategory;
                    _this.setCustomBtnFilter();
                    _this.getPlaces(_this.category);
                }
                else {
                    _this.getPlaces(_this.category, selectedCustomPlaceCategory);
                }
            });
        }
    };
    // CustomDefaultPlaceCategoryAccordionComponent.clearFilter has problem here, so temporarily use this method
    VisitorPlaceMapComponent.prototype.setCustomDefaultPlaceCategoryFilter = function (title) {
        // setTimeout(() => {
        if (this.customDefaultPlaceAccordion) {
            var customDefaultPlaceCategoryTitleSpans = document.querySelectorAll('#place-map-custom-default-category');
            if (customDefaultPlaceCategoryTitleSpans) {
                Array.from(customDefaultPlaceCategoryTitleSpans).forEach(function (x) {
                    var span = x.querySelector('span');
                    span && (span.innerHTML = title || 'FILTER BY CATEGORY');
                });
                if (!title) {
                    var levels = document.querySelectorAll('.category-level span');
                    Array.from(levels).forEach(function (x) {
                        x.style.fontWeight = 'normal';
                        x.style.color = 'rgba(0, 0, 0, 0.87)';
                    });
                }
            }
        }
        // });
    };
    VisitorPlaceMapComponent.prototype.clearCustomBtnFilter = function () {
        this.customPlaceBtns &&
            this.customPlaceBtns.toArray().forEach(function (x) {
                x.clearFilter();
            });
    };
    VisitorPlaceMapComponent.prototype.setCustomBtnFilter = function () {
        var _this = this;
        this.customPlaceBtns.toArray().forEach(function (x) {
            x.setFilter(_this.actionCommand.queryCommand.customPlaceBtnText, _this.actionCommand.queryCommand.choice);
        });
    };
    VisitorPlaceMapComponent.prototype.customPlaceBtnSelected = function (command) {
        console.log('command from event', command);
        this.actionCommand = clone(command);
        this.getPlaces(null);
        this.setCustomDefaultPlaceCategoryFilter();
    };
    Object.defineProperty(VisitorPlaceMapComponent.prototype, "isAllPlaceCategoriesTurnedOff", {
        get: function () {
            return PlaceService.isAllCategoriesTurnedOff(this.featuresToggle.placeCategory);
        },
        enumerable: true,
        configurable: true
    });
    VisitorPlaceMapComponent.prototype.filterPlace = function (category) {
        this.actionCommand.queryCommand.categoryList = null;
        this.actionCommand.queryCommand.selectedPlaces = null;
        this.actionCommand.queryCommand.isCustom = null;
        this.actionCommand.queryCommand.customPlaceBtnText = null;
        var selectedCustomPlaceCategory = null;
        if (this.menuType === 'custom' && category.toLowerCase() === 'all') {
            selectedCustomPlaceCategory = this.initialCustomDefaultPlaceCategory.category;
        }
        this.getPlaces(category, selectedCustomPlaceCategory);
    };
    VisitorPlaceMapComponent.prototype.selectCustomDefaultPlaceCategory = function ($event) {
        var _this = this;
        this.category = $event.title;
        this.actionCommand.isEventCalendar = false;
        this.actionCommand.queryCommand.feedId = null;
        this.actionCommand.queryCommand.category = $event.title;
        this.actionCommand.queryCommand.categoryList = $event.categoryList;
        this.actionCommand.queryCommand.selectedPlaces = null;
        this.actionCommand.queryCommand.isCustom = null;
        this.actionCommand.queryCommand.search = '';
        this.actionCommand.queryCommand.customPlaceBtnText = null;
        localStorage.setItem(localStorageKeys.selectedPlaceCategory, JSON.stringify({
            title: $event.title,
            categoryList: $event.categoryList,
        }));
        this.sideBar.close();
        this.visitorApiService.getPlaces(this.hubName, this.actionCommand.queryCommand).subscribe(function (data) {
            _this.afterGotPlaces(data);
        });
        this.setCustomDefaultPlaceCategoryFilter(this.category);
    };
    VisitorPlaceMapComponent.prototype.isSelected = function (title) {
        return this.actionCommand.queryCommand.category === title;
    };
    VisitorPlaceMapComponent.prototype.getPlaces = function (category, selectedCustomPlaceCategory) {
        var _this = this;
        if (selectedCustomPlaceCategory) {
            // selected custom default place category
            this.isLoading = true;
            this.spinner.show();
            var categoryList = selectedCustomPlaceCategory.categoryList;
            if (!categoryList || !categoryList.length) {
                PlaceService.getAllSubCategories(selectedCustomPlaceCategory, categoryList);
            }
            this.category = selectedCustomPlaceCategory.title;
            this.getPlaceByPage(1, category, categoryList);
        }
        else {
            this.category = category || 'All';
            this.isLoading = true;
            this.actionCommand.queryCommand.limit = config.placeSearchLimit;
            this.actionCommand.queryCommand.category = category;
            this.spinner.show();
            this.visitorApiService.getPlaces(this.hubName, this.actionCommand.queryCommand).subscribe(function (data) {
                _this.afterGotPlaces(data);
            });
        }
    };
    VisitorPlaceMapComponent.prototype.getPlaceByPage = function (page, category, categoryList) {
        var _this = this;
        this.visitorApiService
            .getPlaces(this.hubName, {
            limit: 1000,
            page: page,
            category: category,
            categoryList: categoryList ? categoryList.join(',') : null,
            source: this.dataSource.place,
            isForMapView: true,
        })
            .subscribe(function (data) {
            if (category.toLowerCase() === 'all') {
                _this.getPlaceCategories().subscribe(function (placeCategories) {
                    for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                        var place = data_1[_i];
                        var _loop_1 = function (key) {
                            if (place.categoryList.any(function (x) { return placeCategories[key].any(function (y) { return x === y; }); })) {
                                place.mapIcon = key;
                                return "break";
                            }
                            else {
                                // console.log('not in: ' + place.categoryList.join(', '));
                            }
                        };
                        for (var key in placeCategories) {
                            var state_1 = _loop_1(key);
                            if (state_1 === "break")
                                break;
                        }
                    }
                    _this.afterGotPlaces(data);
                });
            }
            else {
                for (var _i = 0, data_2 = data; _i < data_2.length; _i++) {
                    var place = data_2[_i];
                    place.mapIcon = category;
                }
                _this.afterGotPlaces(data);
            }
            // change URL for an IG default category selected
            if (!categoryList) {
                _this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.placeMap, {
                    hubName: _this.hubName,
                    category: PlaceCategory.getPlaceCategoryKey(category),
                    menuType: _this.simpleMenu ? 'simple' : 'normal',
                }), { skipLocationChange: _this.noChangeUrlWhenRedirect });
            }
        });
    };
    VisitorPlaceMapComponent.prototype.showInfoWindowOnMarker = function (index) {
        var _this = this;
        if (!this.canMarkerMouseOver) {
            return;
        }
        var overlapGroup = [];
        this.markerOverlappings.forEach(function (x) {
            if (x.any(function (y) { return y === index; })) {
                overlapGroup = x;
            }
        });
        if (overlapGroup.length) {
            console.log(overlapGroup.map(function (x) {
                return x;
            }));
            this.groupPlaces = [];
            var lat_1 = 0;
            var lng_1 = 0;
            overlapGroup.forEach(function (x) {
                _this.groupPlaces.push(_this.places[x]);
                var marker = _this.mapMarkers.find(function (m, i) {
                    return i === x;
                });
                lat_1 += marker.latitude;
                lng_1 += marker.longitude;
            });
            this.groupLat = lat_1 / overlapGroup.length;
            this.groupLng = lng_1 / overlapGroup.length;
            this.hideAllSingleInfoWindow();
            this.showGroupInfowWindow = true;
        }
        else {
            this.showInfoWindowByIndex(index);
        }
    };
    VisitorPlaceMapComponent.prototype.showInfoWindowByIndex = function (index) {
        var _this = this;
        this.hideAllSingleInfoWindow();
        this.currentIndex = index;
        setTimeout(function () {
            _this.isInfoWindowsOpen[index] = true;
            _this.showGroupInfowWindow = false;
        });
    };
    VisitorPlaceMapComponent.prototype.groupInfoWindowCloses = function () {
        this.showGroupInfowWindow = false;
    };
    VisitorPlaceMapComponent.prototype.mapZoomChange = function () {
        this.organizeMarkersForOverlapping();
        this.hideAllInfoWindow();
    };
    VisitorPlaceMapComponent.prototype.removeDisplayInfoWindow = function () {
        this.canMarkerMouseOver = false;
    };
    VisitorPlaceMapComponent.prototype.addDisplayInfoWindow = function () {
        var _this = this;
        setTimeout(function () {
            _this.canMarkerMouseOver = true;
        }, 200);
    };
    VisitorPlaceMapComponent.prototype.back = function () {
        var _this = this;
        this.actionCommand.queryCommand.category = this.category;
        this.category = PlaceCategory.getPlaceCategoryKey(this.category);
        console.log('customDefaultPlaceCategory.useDefault', this.customDefaultPlaceCategory);
        // if (!PlaceCategory.isIgDefaultCategory(this.category)) {
        if (!this.customDefaultPlaceCategory.useDefault) {
            // get selected custom category and bring back to calendar
            var selectedPlaceCategoryStr = localStorage.getItem(localStorageKeys.selectedPlaceCategory);
            var selectedCustomPlaceCategory = isJsonString(selectedPlaceCategoryStr)
                ? JSON.parse(selectedPlaceCategoryStr)
                : selectedPlaceCategoryStr;
            // menuType === 'custom' means this category is from URL, e.g., http://localhost:4200/test4/places/62a46ea3e6ad6016f05245ff/custom
            if (this.menuType === 'custom' && typeof selectedCustomPlaceCategory !== 'string') {
                var categoryList = [];
                PlaceService.getAllSubCategories(selectedCustomPlaceCategory || this.initialCustomDefaultPlaceCategory.category, categoryList);
                this.actionCommand.queryCommand.categoryList = categoryList;
                // this.actionCommand.queryCommand.category = this.categoryId;
            }
            else {
                // else means it is from all place calendar
                this.actionCommand.queryCommand.categoryList =
                    typeof selectedCustomPlaceCategory === 'string'
                        ? null
                        : selectedCustomPlaceCategory
                            ? selectedCustomPlaceCategory.categoryList
                            : null;
                this.category = 'All';
                this.actionCommand.queryCommand.category =
                    typeof selectedCustomPlaceCategory === 'string'
                        ? this.category
                        : selectedCustomPlaceCategory
                            ? selectedCustomPlaceCategory.title || this.category
                            : this.category;
            }
        }
        console.log('category in back', this.category);
        console.log('actionCommand in back', this.actionCommand);
        // for custom place button
        if (this.categoryId === 'custom-places') {
            // for map view
            var currentCustomPlaceBtn = this.customPlaces.find(function (x) { return x._id === _this.menuType; });
            console.log('currentCustomPlaceBtn ---', currentCustomPlaceBtn);
            if (currentCustomPlaceBtn) {
                this.actionCommand.queryCommand.customPlaceBtnText = currentCustomPlaceBtn.btnText;
            }
            this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.customPlace, {
                hubName: this.hubName,
                customPlaceBtnId: this.menuType,
            }), { skipLocationChange: this.noChangeUrlWhenRedirect });
        }
        else {
            this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.placeCalendar, {
                hubName: this.hubName,
                category: this.menuType === 'custom' ? this.categoryId : this.category,
                menuType: this.menuType || (this.simpleMenu ? 'simple' : 'normal'),
            }), { skipLocationChange: this.noChangeUrlWhenRedirect });
        }
        this.actionCommand.isEventCalendar = false;
        this.actionCommand.isMapView = false;
        this.actionCommand.queryCommand.limit = 16;
        this.actionCommand.queryCommand.isForMapView = null;
        this.visitorCalendarStore.actionCommand.next(this.actionCommand);
    };
    VisitorPlaceMapComponent.prototype.pagingBack = function () {
        if (this.noMoreBack) {
            return;
        }
        this.paginationIndex--;
        var start = this.paginationPageLimit * this.paginationIndex;
        var end = start + this.paginationPageLimit;
        if (start <= 0) {
            start = 0;
            this.noMoreBack = true;
        }
        this.places = this.allPlaces.slice(start, end);
        this.showingCount = start + 1 + " - " + end;
        this.noMoreNext = false;
        this.fitBounds();
    };
    VisitorPlaceMapComponent.prototype.pagingNext = function () {
        if (this.noMoreNext) {
            return;
        }
        this.paginationIndex++;
        var start = this.paginationPageLimit * this.paginationIndex;
        var end = start + this.paginationPageLimit;
        if (end >= this.allPlaces.length) {
            end = this.allPlaces.length;
            this.noMoreNext = true;
        }
        this.places = this.allPlaces.slice(start, end);
        this.showingCount = start + 1 + " - " + end;
        this.noMoreBack = false;
        this.fitBounds();
    };
    VisitorPlaceMapComponent.prototype.resizeMap = function () {
        this.isMapFullSize = !this.isMapFullSize;
    };
    VisitorPlaceMapComponent.prototype.getPlaceCategories = function () {
        var _this = this;
        if (!VisitorDataCache.placeCategories || !VisitorDataCache.placeCategories.length) {
            return Observable.create(function (observable) {
                _this.visitorApiService.getPlaceCategories().subscribe(function (data) {
                    VisitorDataCache.placeCategories = data;
                    observable.next(data);
                    observable.complete();
                });
            });
        }
        else {
            return Observable.of(VisitorDataCache.placeCategories);
        }
    };
    VisitorPlaceMapComponent.prototype.afterGotPlaces = function (data) {
        var _this = this;
        this.allPlaces = data;
        this.paginationIndex = 0;
        this.showingCount = null;
        if (data.length > this.paginationPageLimit) {
            var max = this.paginationPageLimit * (this.paginationIndex + 1);
            this.places = data.slice(0, max);
            this.noMoreNext = false;
            this.noMoreBack = true;
            this.showingCount = this.paginationPageLimit * this.paginationIndex + 1 + " - " + max;
        }
        else {
            this.places = data;
        }
        this.places.forEach(function (x) {
            _this.isInfoWindowsOpen.push(false);
        });
        this.fitBounds();
        setTimeout(function () {
            _this.isLoading = false;
            _this.isInitLoading = false;
            _this.spinner.hide();
        });
    };
    VisitorPlaceMapComponent.prototype.organizeMarkersForOverlapping = function () {
        var _this = this;
        this.markerOverlappings = [];
        this.mapMarkers.forEach(function (x, indexX) {
            _this.mapMarkers.forEach(function (y, indexY) {
                if (x !== y) {
                    if (_this.isMarkersOverlapping(x, y)) {
                        var toInsert_1 = true;
                        _this.markerOverlappings.forEach(function (m) {
                            if (m.any(function (o) { return o === indexX || o === indexY; })) {
                                if (!m.any(function (o) { return o === indexX; })) {
                                    m.push(indexX);
                                }
                                if (!m.any(function (o) { return o === indexY; })) {
                                    m.push(indexY);
                                }
                                toInsert_1 = false;
                            }
                        });
                        if (toInsert_1) {
                            _this.markerOverlappings.push([indexX, indexY]);
                        }
                    }
                }
            });
        });
    };
    VisitorPlaceMapComponent.prototype.isMarkersOverlapping = function (marker1, marker2) {
        var zoom = this.map.zoom;
        var dis = GeoService.getDistanceFromLatLng(marker1.latitude, marker1.longitude, marker2.latitude, marker2.longitude);
        var metersPerPx = (156543.03392 * Math.cos((marker1.latitude * Math.PI) / 180)) / Math.pow(2, zoom);
        var pxDistance = dis / metersPerPx;
        return pxDistance <= 10;
    };
    VisitorPlaceMapComponent.prototype.hideAllSingleInfoWindow = function () {
        if (this.isInfoWindowsOpen && this.isInfoWindowsOpen.length) {
            for (var i = 0; i < this.isInfoWindowsOpen.length; i++) {
                this.isInfoWindowsOpen[i] = false;
            }
        }
    };
    VisitorPlaceMapComponent.prototype.hideAllInfoWindow = function () {
        this.hideAllSingleInfoWindow();
        this.showGroupInfowWindow = false;
    };
    VisitorPlaceMapComponent.prototype.gotoDetails = function (id) {
        var _this = this;
        if (!id)
            return;
        this.visitorApiService.getPlaces(this.hubName, { id: id }).subscribe(function (places) {
            if (!_this.isMobile) {
                var actions = {
                    confirm: function (event, data) {
                    },
                };
                _this.modalService.show({
                    component: PlaceDetailsModalComponent,
                    providers: [
                        { provide: PlaceDetailsModalActions, useValue: actions },
                        { provide: HubPlace, useValue: places[0] },
                    ],
                    panelClass: 'modal-fixed-top',
                });
            }
            else {
                _this.showDetailModalForMobile(places[0], 'place');
            }
        });
    };
    VisitorPlaceMapComponent.prototype.showDetailModalForMobile = function (item, displayingOn, isShowAddToTripBtn, index) {
        if (isShowAddToTripBtn === void 0) { isShowAddToTripBtn = false; }
        var actions = {
            confirm: function (event) {
            },
        };
        this.modalService.show({
            component: TripDetailModalComponent,
            providers: [
                { provide: TripDetailModalActions, useValue: actions },
                {
                    provide: TripDetailModalData,
                    useValue: new TripDetailModalData(item, displayingOn, this.hubName, null, null, isShowAddToTripBtn, index),
                },
            ],
            panelClass: ['width-modal-100p', 'ig-trip-info-modal'],
        });
    };
    VisitorPlaceMapComponent.prototype.fitBounds = function () {
        var _this = this;
        if (!this.places || !this.places.length) {
            return;
        }
        this.googleMapService.getGoogle().then(function () {
            _this.latLngBounds = new google.maps.LatLngBounds();
            _this.places.forEach(function (x) {
                if (x.lat && x.lng) {
                    _this.latLngBounds.extend(new google.maps.LatLng(x.lat, x.lng));
                }
            });
        });
    };
    return VisitorPlaceMapComponent;
}(BaseComponent));
export { VisitorPlaceMapComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/place.map/visitor.place.map.component.ts.pre-build-optimizer.js